<template>
  <!-- 内勤角色 -->
  <div class="main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">适用机构</span>
          <selectTree v-model="searchObj.organizationId" :multiple="false" type="4"></selectTree>
        </div>

        <div class="input-item">
          <span class="label">角色名称</span>
          <Input v-model="searchObj.name" placeholder="请输入" clearable />
        </div>

        <div class="input-item">
          <span class="label">角色code</span>
          <Input v-model="searchObj.code" placeholder="请输入" clearable />
        </div>

        <!-- <div class="input-item">
                    <span class="label">手机号</span>
                    <Input v-model="searchObj.mobile" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">工号</span>
                    <Input v-model="searchObj.staffNo" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">姓名</span>
                    <Input v-model="searchObj.userName" placeholder="请输入" clearable />
                </div> -->
        <div class="btn-item">
          <Button type="primary" @click="getList()">搜索</Button>
          <Button type="primary" ghost @click="reset">重置</Button>
          <!-- <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
                        >收起
                        <Icon type="ios-arrow-up" />
                    </Button>
                    <Button type="primary" ghost v-else @click="searchMore = true"
                        >展开
                        <Icon type="ios-arrow-down" />
                    </Button> -->
        </div>
      </div>
      <div class="tools-box right">
        <Button type="warning" @click="addRole" v-if="$units.pointAction('org_5_2')">新增角色</Button>
      </div>

      <div class="tableBox setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <div class="table-box">
          <Table :columns="columns" :data="tableDate">
            <template slot-scope="{ row }" slot="name">
              <a class="counts" @click="$refs.changeRole.open(row)">{{ row.name }}</a>
            </template>

            <template slot-scope="{ row }" slot="counts">
              <a class="counts" @click="$refs.workersNum.open(row)">{{ row.counts }}</a>
            </template>

            <template slot-scope="{ row }" slot="isSyncNew">
              <Tag color="primary" v-if="row.isSyncNew == 1">是</Tag>
              <Tag color="error" v-else>否</Tag>
            </template>

            <template slot-scope="{ row }" slot="action">
              <div class="table-btn" @click="authority(row)">权限</div>
              <Dropdown
                :transfer="true"
                trigger="hover"
                transfer-class-name="salesman-manage-dropdown-menu"
                @on-click="dropdownClick($event, row)"
                v-if="$units.pointAction('org_5_2') || $units.pointAction('org_5_3')"
              >
                <div class="more-btn">
                  操作
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="1" v-if="$units.pointAction('org_5_2')" :disabled="row.isCurrentRoles == 1 ? true : false"
                    ><i class=""></i>编辑</DropdownItem
                  >
                  <DropdownItem name="4" v-if="$units.pointAction('org_5_2')"><i class=""></i>复制</DropdownItem>
                  <DropdownItem name="3" v-if="$units.pointAction('org_5_3')" :disabled="row.counts != '0' || row.isCurrentRoles == 1 ? true : false"
                    ><i class=""></i>删除</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </template>
          </Table>
          <div class="pageBox">
            <Page
              :total="total"
              :current="searchObj.pageNo"
              :page-size="searchObj.pageSize"
              show-total
              @on-change="pageChange_table"
              style="text-align: center"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 修改 -->
    <change-role ref="changeRole" :getList="getList"></change-role>

    <!-- 内勤人数 -->
    <workersNumber ref="workersNum"></workersNumber>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import changeRole from './components/changeRole';
import workersNumber from './components/workersNumber';
export default {
  components: {
    selectTree,
    changeRole,
    workersNumber
  },
  mixins: [pageTool, common],
  data() {
    return {
      searchObj: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      columns: [
        {
          title: '序号',
          width: 80,
          align: 'center',
          type: 'index'
        },
        {
          title: '角色code',
          key: 'code',
          width: 350,
          align: 'center'
        },
        {
          title: '角色名称',
          minWidth: 200,
          align: 'center',
          tooltip: true,
          slot: 'name'
        },
        {
          title: '适用机构',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return <span>{params.row.organizationNames ? params.row.organizationNames : '-'}</span>;
          }
        },

        {
          title: '内勤账号',
          minWidth: 100,
          align: 'center',
          slot: 'counts'
        },
        {
          title: '自动同步新菜单',
          minWidth: 120,
          align: 'center',
          slot: 'isSyncNew'
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          minWidth: 180,
          tooltip: true
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 150,
          fixed: 'right'
        }
      ],
      tableDate: []
    };
  },

  activated() {
    this.getList();
  },

  methods: {
    //分页切换页码
    pageChange_table(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.getList();
    },

    //列表
    getList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/rolesExt/listRoles',
        type: 'POST',
        data: this.searchObj,
        apiPermissionCode: 'org_5_0'
      })
        .then(res => {
          this.total = res.total;
          this.tableDate = res.data;
          this.$root.$children[0].isShowLoading = false;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },

    // 重置
    reset() {
      this.searchObj = {
        pageNo: 1,
        pageSize: 10
      };
      this.getList();
    },

    //新增角色
    addRole() {
      this.$router.push({
        path: '/systemSet/roleManageAdd',
        query: {
          t: new Date().getTime(),
          backUrl: this.delQueStr(this.$route.fullPath, 'time')
        }
      });
    },

    // 权限
    authority(row) {
      this.$router.push({
        path: '/systemSet/roleManageAuthority',
        query: {
          id: row.id,
          isAuth: 1,
          isCurrentRoles:row.isCurrentRoles
        }
      });
    },

    // 编辑
    dropdownClick(e, row) {
      if (e == '1') {
        this.$refs.changeRole.open(row);
      } else if (e == '3') {
        this.$notice.inquiry('确认删除该角色？').then(async () => {
          this.$http({
            url: `/buz/rolesExt/deleteById`,
            type: 'GET',
            data: {
              id: row.id
            },
            apiPermissionCode: 'org_5_3'
          }).then(res => {
            this.$Message.success('删除成功');
            this.getList();
          });
        });
      } else if (e == '4') {
        this.$router.push({
          path: '/systemSet/roleManageAdd',
          query: {
            id: row.id,
            isCopy: 1
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-table-cell-slot .detail > div {
  margin-right: 10px;
  font-size: 13px;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .formGroup {
  position: relative;

  &:after {
    position: absolute;
    bottom: -15px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  padding: 0;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}

.pageBox {
  margin-top: 20px;
}

@import './index.scss';
</style>
